import api from "../utils/API";

const getAllNiveauxAnglaisForSelect = () => {
  return api.get(`/gestion/niveauxanglaisforselect/list`);
};

export {getAllNiveauxAnglaisForSelect};
